import { render, staticRenderFns } from "./gameDetail.vue?vue&type=template&id=6097f8e0&"
import script from "./gameDetail.vue?vue&type=script&lang=js&"
export * from "./gameDetail.vue?vue&type=script&lang=js&"
import style0 from "./gameDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6097f8e0')) {
      api.createRecord('6097f8e0', component.options)
    } else {
      api.reload('6097f8e0', component.options)
    }
    module.hot.accept("./gameDetail.vue?vue&type=template&id=6097f8e0&", function () {
      api.rerender('6097f8e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/gameDetail.vue"
export default component.exports